import isEmpty from "lodash-es/isEmpty";
import React from "react";

import { Text } from "@/components/Text";
import { fetchCodelist, ICodelist, IFetchCodelistParams } from "@/data/codelists";
import { Checkbox, Flex } from "@/eworkitComponents";
import { useCodelistTranslation } from "@/hooks/Codelist";
import { useFetcher } from "@/hooks/http";
import { IFilterComponentProps, useOnChangeFilterHandler } from "@/infrastructure/Filter";

const TASK_TYPES_CODELIST: IFetchCodelistParams = { codelistName: "task-types" };

interface Props extends IFilterComponentProps {}

const TaskTypeFilterComponent: React.FC<Props> = ({ value = [], onChange, name }) => {
  const { payload: allOptions } = useFetcher(fetchCodelist, TASK_TYPES_CODELIST);
  const tCodelist = useCodelistTranslation();

  const handleChange = useOnChangeFilterHandler(name, onChange);

  const handleOptionChange = (optionValue: ICodelist, checked: boolean) => {
    if (checked) {
      handleChange([...value, optionValue.code]);
    } else {
      handleChange(value.filter((o: string) => o !== optionValue.code));
    }
  };

  if (isEmpty(allOptions)) {
    return null;
  }

  return (
    <Flex direction="column">
      {allOptions &&
        allOptions.map(option => (
          <Checkbox
            key={option.code}
            checked={value?.some((v: string) => v === option.code)}
            onChange={v => handleOptionChange(option, v)}>
            <Text size="md" color="black">
              {tCodelist(TASK_TYPES_CODELIST.codelistName, option.code)}
            </Text>
          </Checkbox>
        ))}
    </Flex>
  );
};

export const TaskTypeFilter = React.memo(TaskTypeFilterComponent);
